<div class="item-list-component" [ngClass]="{ 'dx-rtl': rtlEnabled }" dir="{{rtlEnabled ? 'rtl' : 'ltr'}}">
  <div class="grid-buttons">
    <dx-button hint="{{ 'SHARED.ADD' | translate }}" icon="add" (onClick)="add()"></dx-button>
  </div>
  <dx-data-grid #productClockFaceGrid id="printSection" [rtlEnabled]="rtlEnabled" [dataSource]="items"
                [showBorders]="true"
                [allowColumnReordering]="true"
                [hoverStateEnabled]="true"
                [columnAutoWidth]="true"
                [rowAlternationEnabled]="true"
                (onRowClick)="edit($event)"
                (onExporting)="onExporting($event)">
    <!--<<dxo-export [enabled]="true"></dxo-export>>-->
    <dxo-selection mode="single"></dxo-selection>
    <dxo-filter-row [visible]="true"></dxo-filter-row>
    <dxo-filter-panel [visible]="true"></dxo-filter-panel>
    <dxo-header-filter [visible]="true"></dxo-header-filter>
    <!--<dxo-search-panel [visible]="true"></dxo-search-panel>-->
    <dxo-pager [visible]="true"
               [showPageSizeSelector]="true"
               [allowedPageSizes]="[5, 10, 20, 30, 40, 50, 100, 200]"
               [showNavigationButtons]="true"
               [showInfo]="true"
               infoText="{2} {{ 'SHARED.PAGINATION_TEXT_PLACEHOLDER' | translate | slice:2 }}">
    </dxo-pager>
    <dxi-column [editorOptions]="{ showClearButton: true }" dataType="string" dataField="name" caption="{{ 'SHARED.NAME' | translate }}">
    </dxi-column>
    <dxi-column [editorOptions]="{ showClearButton: true }" dataType="string" dataField="rowNumber" caption="{{ 'PRODUCT.PROPERTY.ROW_NUMBER' | translate }}">
    </dxi-column>
    <dxi-column [editorOptions]="{ showClearButton: true }" dataType="string" dataField="columnNumber" caption="{{ 'PRODUCT.PROPERTY.COLUMN_NUMBER' | translate }}">
    </dxi-column>
    <dxi-column [editorOptions]="{ showClearButton: true }" dataType="string" dataField="marginLeft" caption="{{ 'PRODUCT.CLOCKFACE.MARGIN_LEFT' | translate }}">
    </dxi-column>
    <dxi-column [editorOptions]="{ showClearButton: true }" dataType="string" dataField="width" caption="{{ 'PRODUCT.PROPERTY.WIDTH_PERCENTAGE' | translate }}">
    </dxi-column>
    <dxi-column [editorOptions]="{ showClearButton: true }" dataType="string" dataField="marginRight" caption="{{ 'PRODUCT.CLOCKFACE.MARGIN_RIGHT' | translate }}">
    </dxi-column>
    <dxi-column [editorOptions]="{ showClearButton: true }" dataType="string" dataField="marginTop" caption="{{ 'PRODUCT.CLOCKFACE.MARGIN_TOP' | translate }}">
    </dxi-column>
    <dxi-column [editorOptions]="{ showClearButton: true }" dataType="string" dataField="height" caption="{{ 'PRODUCT.PROPERTY.HEIGHT' | translate }}">
    </dxi-column>
    <dxi-column [editorOptions]="{ showClearButton: true }" dataType="string" dataField="labelHeight" caption="{{ 'PRODUCT.CLOCKFACE.LABEL_HEIGHT' | translate }}">
    </dxi-column>
    <dxi-column [editorOptions]="{ showClearButton: true }" dataType="string" dataField="marginBottom" caption="{{ 'PRODUCT.CLOCKFACE.MARGIN_BOTTOM' | translate }}">
    </dxi-column>

    <dxi-column type="buttons" [width]="70">
      <dxi-button hint="{{ 'SHARED.EDIT' | translate }}" icon="edit" [onClick]="edit"></dxi-button>
      <dxi-button hint="{{ 'SHARED.DELETE' | translate }}" icon="trash" [onClick]="deleteItem"></dxi-button>
    </dxi-column>
  </dx-data-grid>
</div>
  
  <product-clockface-component #details (onDetailsClosed)="onDetailsClosed($event)"></product-clockface-component>
  <confirmation-component #confirmation title="{{ 'PRODUCT.CLOCKFACE.DELETE' | translate }}"
                          message="{{ 'PRODUCT.CLOCKFACE.DELETE_MESSAGE' | translate }}"
                          buttonCloseText="DELETE" cancellable="true" (close)="deleteSelected();"></confirmation-component>
